var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowAside(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 40,
    viewBox: "0 0 10 40",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 20 4.5 33 10 40H0V0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDEwIDQwIiBmaWxsPSJub25lIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTAgOC4wODQwM2UtMDdDMi43MDIxM2UtMDYgMjAgNC41IDMzIDEwIDQwTDQuNDUwNTllLTA2IDQwTDIuNzAyMTNlLTA2IDIwTDAgOC4wODQwM2UtMDdaIgogICAgICAgIGZpbGw9ImN1cnJlbnRDb2xvciIKICAgIC8+Cjwvc3ZnPg==";
export { SvgArrowAside as ReactComponent };